import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** ユーザ情報 */
export interface IUserAttr {
	userId: string;
	locale: string;
	lang: string;
	managerChk: string;
	authorityList: string[];
	loginType: string;
	userName: string;
	userFamilyName: string;
}

/**
 * セッションログインID設定アクションクリエータ
 */
export const setSessionLoginID = actionCreator<{
	loginID: string;
}>('SET_SESSION_LOGIN_ID');

/**
 * セッショントークン設定アクションクリエータ
 */
export const setSessionToken = actionCreator<{
	token: string;
}>('SET_SESSION_TOKEN');

/**
 * セッションユーザ情報設定アクションクリエータ
 */
export const setSessionUserAttr = actionCreator<{
	userAttr: IUserAttr;
}>('SET_SESSION_USER_ATTR');

/**
 * セッション情報初期化アクションクリエータ
 */
export const clearSession = actionCreator('CLEAR_SESSION');



// WEBPACK FOOTER //
// ./src/actions/session.ts